import UserRegList from "../../components/userRegistration/UserRegList";


const Page=()=>{

  return <>
  <UserRegList />
  </>
}

export default Page;